module.exports = __webpack_public_path__ + "img/pm.c7849900.svg";